import { SearchData } from './types-store';
import { AccessPerson, ExtraInfoCodeValues } from 'app/components/access-panel/shared/types';
import { FilterSearchModel } from 'app/area/search-filters/types-store';
import { DefaultRole } from 'app/area/administration/shared/types';

export const ACTION = {
  CLEAR_LIST: 'ADMINISTRATION_SEARCH:CLEAR_LIST',

  REQUEST_PERSON_ACCESS: 'ADMINISTRATION_SEARCH:REQUEST_PERSON_ACCESS',
  RECEIVE_PERSON_ACCESS: 'ADMINISTRATION_SEARCH:RECEIVE_PERSON_ACCESS',
  FAIL_PERSON_ACCESS: 'ADMINISTRATION_SEARCH:FAIL_PERSON_ACCESS',
  CLEAR_PERSON_ACCESS: 'ADMINISTRATION_SEARCH:CLEAR_PERSON_ACCESS',

  REQUEST_LIST: 'ADMINISTRATION_SEARCH:REQUEST_LIST',
  RECEIVE_LIST: 'ADMINISTRATION_SEARCH:RECEIVE_LIST',
  FAIL_LIST: 'ADMINISTRATION_SEARCH:FAIL_LIST',

  REQUEST_DELETE: 'ADMINISTRATION_SEARCH:REQUEST_DELETE',
  RECEIVE_DELETE: 'ADMINISTRATION_SEARCH:RECEIVE_DELETE',
  FAIL_DELETE: 'ADMINISTRATION_SEARCH:FAIL_DELETE',

  REQUEST_USER_EXPORT_EXCEL: 'ADMINISTRATION_SEARCH:REQUEST_USER_EXPORT_EXCEL',
  RECEIVE_USER_EXPORT_EXCEL: 'ADMINISTRATION_SEARCH:RECEIVE_USER_EXPORT_EXCEL',
  FAIL_USER_EXPORT_EXCEL: 'ADMINISTRATION_SEARCH:FAIL_USER_EXPORT_EXCEL',

  REQUEST_ROLE_EXPORT_EXCEL: 'ADMINISTRATION_SEARCH:REQUEST_ROLE_EXPORT_EXCEL',
  RECEIVE_ROLE_EXPORT_EXCEL: 'ADMINISTRATION_SEARCH:RECEIVE_ROLE_EXPORT_EXCEL',
  FAIL_ROLE_EXPORT_EXCEL: 'ADMINISTRATION_SEARCH:FAIL_ROLE_EXPORT_EXCEL',

  REQUEST_DEFAULT_ROLE: 'ADMINISTRATION_SEARCH:REQUEST_DEFAULT_ROLE',
  RECEIVE_DEFAULT_ROLE: 'ADMINISTRATION_SEARCH:RECEIVE_DEFAULT_ROLE',
  FAIL_DEFAULT_ROLE: 'ADMINISTRATION_SEARCH:FAIL_DEFAULT_ROLE',
  REQUEST_SET_DEFAULT_ROLE: 'ADMINISTRATION_SEARCH:REQUEST_SET_DEFAULT_ROLE',
  RECEIVE_SET_DEFAULT_ROLE: 'ADMINISTRATION_SEARCH:RECEIVE_SET_DEFAULT_ROLE',
  FAIL_SET_DEFAULT_ROLE: 'ADMINISTRATION_SEARCH:FAIL_SET_DEFAULT_ROLE',

  REQUEST_EXTRA_INFO: 'ADMINISTRATION_SEARCH:REQUEST_EXTRA_INFO',
  RECEIVE_EXTRA_INFO: 'ADMINISTRATION_SEARCH:RECEIVE_EXTRA_INFO',
  FAIL_EXTRA_INFO: 'ADMINISTRATION_SEARCH:FAIL_EXTRA_INFO',

  REQUEST_CHECK_ROLES: 'ADMINISTRATION_SEARCH:REQUEST_CHECK_ROLES',
  RECEIVE_CHECK_ROLES: 'ADMINISTRATION_SEARCH:RECEIVE_CHECK_ROLES',
  FAIL_CHECK_ROLES: 'ADMINISTRATION_SEARCH:FAIL_CHECK_ROLES'
};

export class ClearList {
  public type: string = ACTION.CLEAR_LIST;
  constructor(public requestId: number) {
  }
}

export class RequestPersonAccess {
  public type: string = ACTION.REQUEST_PERSON_ACCESS;
}

export class ReceivePersonAccess {
  public type: string = ACTION.RECEIVE_PERSON_ACCESS;
  constructor(public access: AccessPerson) { }
}

export class FailPersonAccess {
  public type: string = ACTION.FAIL_PERSON_ACCESS;
  constructor(public requestId: number) {
  }
}

export class ClearPersonAccess {
  public type: string = ACTION.CLEAR_PERSON_ACCESS;
}

export class RequestList {
  public type: string = ACTION.REQUEST_LIST;
  constructor(public requestId: number, public model: FilterSearchModel, public clearResults: boolean) {
  }
}

export class ReceiveList {
  public type: string = ACTION.RECEIVE_LIST;
  constructor(public requestId: number, public list: SearchData[], public total: number) { }
}

export class FailList {
  public type: string = ACTION.FAIL_LIST;
  constructor(public requestId: number) {
  }
}

export class RequestDelete {
  public type: string = ACTION.REQUEST_DELETE;
  constructor(public id: number) {
  }
}

export class ReceiveDelete {
  public type: string = ACTION.RECEIVE_DELETE;
  constructor(public id: number) {
  }
}

export class FailDelete {
  public type: string = ACTION.FAIL_DELETE;
  constructor(public id: number) {
  }
}

export class RequestUserExportExcel {
  public type: string = ACTION.REQUEST_USER_EXPORT_EXCEL;
}

export class ReceiveUserExportExcel {
  public type: string = ACTION.RECEIVE_USER_EXPORT_EXCEL;
}

export class FailUserExportExcel {
  public type: string = ACTION.FAIL_ROLE_EXPORT_EXCEL;
}

export class RequestRoleExportExcel {
  public type: string = ACTION.REQUEST_ROLE_EXPORT_EXCEL;
}

export class ReceiveRoleExportExcel {
  public type: string = ACTION.RECEIVE_ROLE_EXPORT_EXCEL;
}

export class FailRoleExportExcel {
  public type: string = ACTION.FAIL_ROLE_EXPORT_EXCEL;
}

export class RequestDefaultRole {
  public type: string = ACTION.REQUEST_DEFAULT_ROLE;
}

export class ReceiveDefaultRole {
  public type: string = ACTION.RECEIVE_DEFAULT_ROLE;
  constructor(public defaultRole: DefaultRole) { }
}

export class FailDefaultRole {
  public type: string = ACTION.FAIL_DEFAULT_ROLE;
}

export class RequestSetDefaultRole {
  public type: string = ACTION.REQUEST_SET_DEFAULT_ROLE;
  constructor(public settingDefaultRoleId: number) { }
}

export class ReceiveSetDefaultRole {
  public type: string = ACTION.RECEIVE_SET_DEFAULT_ROLE;
}

export class FailSetDefaultRole {
  public type: string = ACTION.FAIL_SET_DEFAULT_ROLE;
}

export class RequestExtraInfo {
  public type: string = ACTION.REQUEST_EXTRA_INFO;
}

export class ReceiveExtraInfo {
  public type: string = ACTION.RECEIVE_EXTRA_INFO;
  constructor(public extraInfoCodes: ExtraInfoCodeValues[]) { }
}

export class FailExtraInfo {
  public type: string = ACTION.FAIL_EXTRA_INFO;
}

export class RequestCheckRoles {
  public type: string = ACTION.REQUEST_CHECK_ROLES;
}

export class ReceiveCheckRoles {
  public type: string = ACTION.RECEIVE_CHECK_ROLES;
  constructor(public hasRoles: boolean) { }
}

export class FailCheckRoles {
  public type: string = ACTION.FAIL_CHECK_ROLES;
}
